function Footer() {
    return(
        <footer className='footer container-fluid'> 
        <p className="footer-txt">A     S-E-T-D Production - est.2022</p>
        <a href="https://www.youtube.com/watch?v=dQw4w9WgXcQ"><img className="icons " src="https://i.imgur.com/DAoLUZT.png"></img></a> 
        <a href="https://www.youtube.com/watch?v=dQw4w9WgXcQ"><img className="icons " src="https://i.imgur.com/2xQcEyZ.png"></img></a>
        <a href="https://www.youtube.com/watch?v=dQw4w9WgXcQ"><img className="icons " src="https://i.imgur.com/hGHDoGh.png"></img></a>
        <a href="https://www.youtube.com/watch?v=dQw4w9WgXcQ"><img className="icons " src="https://i.imgur.com/XHJNMXY.png"></img></a>
        <a href="https://www.youtube.com/watch?v=dQw4w9WgXcQ"><img className="icons " src="https://i.imgur.com/tiY6XcV.png"></img></a>
        <a href="https://www.youtube.com/watch?v=dQw4w9WgXcQ"><img className="icons " src="https://i.imgur.com/ipCWaij.png"></img></a>
        <a href="https://www.youtube.com/watch?v=dQw4w9WgXcQ"><img className="icons " src="https://i.imgur.com/ViURnKB.png"></img></a>
        <a href="https://www.youtube.com/watch?v=dQw4w9WgXcQ"><img className="icons " src="https://i.imgur.com/FSIJSoN.png"></img></a>
        <a href="https://www.youtube.com/watch?v=dQw4w9WgXcQ"><img className="icons " src="https://i.imgur.com/nhvu18j.png"></img></a>
        
        </footer>
    )
}

export default Footer;